import { render, staticRenderFns } from "./NotificationsColumns.vue?vue&type=template&id=2723a3d9&"
import script from "./NotificationsColumns.vue?vue&type=script&lang=js&"
export * from "./NotificationsColumns.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/build/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2723a3d9')) {
      api.createRecord('2723a3d9', component.options)
    } else {
      api.reload('2723a3d9', component.options)
    }
    module.hot.accept("./NotificationsColumns.vue?vue&type=template&id=2723a3d9&", function () {
      api.rerender('2723a3d9', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components-globalwork/notifications/NotificationsColumns.vue"
export default component.exports